module.exports = __webpack_public_path__ + "static/fipccartoongiraffe-60353a586134e92ed0fc1640f9febc64.jpeg";